import { getFormState, isChartType, setFormValues } from 'adapter/in/common/form/populateForm';
import { ConfigFieldType } from 'adapter/in/common/form/types';
import {
    getOptionsFormByWidgetType,
    populateCustomOptionsCharts,
    populateCustomOptionsGauge,
} from 'adapter/in/dashboards/containers/EditDashboard/WidgetMenu/Panel/Configuration/Tabs/Options';
import PresetFormField, { TextPresetFormField } from 'domain/entity/preset/form/presetFormField';
import Widget, { WidgetConfigurationField, WidgetOptionConfigurationField, WidgetType } from 'domain/entity/widget';
import { WidgetDataTypes } from 'domain/entity/widgetData';
import ChartData from 'domain/entity/widgets/ChartData';
import GaugeData from 'domain/entity/widgets/GaugeData';
import { FieldValues, UseFormSetValue } from 'react-hook-form';

export const populateAddWidgetForm = (fields: PresetFormField[], setValue: UseFormSetValue<FieldValues>): void => {
    setFormValues(setValue, Object.assign({}, ...[getFormState(fields, ConfigFieldType.DATA)]));
};

const generateDummyPresetField = (field: WidgetConfigurationField | WidgetOptionConfigurationField) =>
    new TextPresetFormField(field.key, '', [], '', 100);

export const populateEditDataWidgetForm = (
    widget: Widget,
    widgetType: WidgetType,
    fields: PresetFormField[],
    setValue: UseFormSetValue<FieldValues>
): void => {
    setFormValues(
        setValue,
        Object.assign(
            {},
            ...[getFormState(fields, ConfigFieldType.DATA, widget.configurationFields)],
            ...[
                getFormState(
                    widget.optionFields.map((field) => generateDummyPresetField(field)),
                    ConfigFieldType.OPTIONS,
                    [...widget.optionFields.filter((option) => typeof option.value === 'string')]
                ),
            ]
        )
    );
    if (widgetType === WidgetType.GAUGE) populateCustomOptionsGauge(widget, setValue);
    if (isChartType(widgetType)) {
        populateCustomOptionsCharts(widget, setValue);
    }
};

export const populateEditOptionsWidgetForm = (
    widget: Widget,
    widgetType: WidgetType,
    widgetDataTypes: WidgetDataTypes,
    setValue: UseFormSetValue<FieldValues>
): void => {
    const optionsString = [...widget.optionFields.filter((option) => typeof option.value === 'string')];
    const fields = widget.configurationFields.map((field) => generateDummyPresetField(field));
    const data = getFormState(fields, ConfigFieldType.DATA, widget.configurationFields);
    const options = getOptionsFormByWidgetType(widgetType)
        .map((optionContainer) => optionContainer.fields)
        .map((optionField) => getFormState(optionField, ConfigFieldType.OPTIONS, optionsString, widgetDataTypes));
    setFormValues(setValue, Object.assign({}, ...[data], ...options));
    if (widgetType === WidgetType.GAUGE) populateCustomOptionsGauge(widget, setValue, widgetDataTypes as GaugeData);
    if (isChartType(widgetType)) {
        populateCustomOptionsCharts(widget, setValue, widgetDataTypes as ChartData);
    }
};
